<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">SC-ST Cell Committee</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">SC-ST Cell Committee</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="minority-cell ptb--100 ">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-bordered table-striped table--4">
            <thead>
              <tr>
                <th>Sr.No.</th>
                <th>Name of the Faculty</th>
                <th>Designation</th>
                <th>Role in Committee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Prof. Sarika Kulthe</td>
                <td>HoD Bcom</td>
                <td>Chairman</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Prof. Prafulla Jadhav</td>
                <td>HoD BSc (CS)</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Prof. Venkat Wadgave</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>4.</td>
                <td>Prof. Snehal Dalvi</td>
                <td>Asst. Prof.</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>5.</td>
                <td>Mr. Aniket Waghule</td>
                <td>Student Representative BBA (CA)</td>
                <td>Member</td>
              </tr>
              <tr>
                <td>6.</td>
                <td>Ms. Snehal Thele</td>
                <td>Student Representative B.Sc (CS)</td>
                <td>Member</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
